import React from 'react';
import { UserIcon } from 'lucide-react';
interface ToolCardHeaderProps {
  subtitle: string;
  badge?: string;
}
export function ToolCardHeader({
  subtitle,
  badge
}: ToolCardHeaderProps) {
  return <header className="flex items-start gap-3.5 border-b border-gray-100 px-5 py-5 sm:px-6" data-id="element-316" data-mp="23cv00dps426u">
      <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-navy-600" data-id="element-317" data-mp="28awk91yxy7jw">
        <UserIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-318" data-mp="1tdnnttus6dlb" />
      </div>
      <div className="min-w-0 flex-1" data-id="element-319" data-mp="1yd0cmk57puqj">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1" data-id="element-320" data-mp="1ye1ourxysn9u">
          <h1 className="text-base font-semibold text-gray-900 sm:text-lg" data-id="element-321" data-mp="1ke0m16y535rq">
            User Offboarding Tool — Person Accounts &amp; Leads
          </h1>
          {badge && <span className="rounded-md bg-gray-100 px-2 py-0.5 text-[11px] font-medium text-gray-600" data-id="element-322" data-mp="3erid33xr6kri">
              {badge}
            </span>}
        </div>
        <p className="mt-0.5 text-sm text-gray-500" data-id="element-323" data-mp="3jptmxeo1sv9q">{subtitle}</p>
      </div>
    </header>;
}